import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, useRouteMatch, useLocation } from 'react-router-dom'
import queryString from 'query-string'

import { pathHelper } from '../../utils'

export const RouteValidation = ({ paramKey, queryKey, schema, redirectTo, children, ...rest }) => {
  const { params, path } = useRouteMatch()
  const { search } = useLocation()
  const query = queryString.parse(search)

  const schemaValues = React.useMemo(() => Object.values(schema), [schema])

  return schemaValues.some((value) => value === params[paramKey] || value === query[queryKey]) ? (
    React.cloneElement(children, rest)
  ) : (
    <Redirect to={redirectTo ?? pathHelper.findRoot(path)} />
  )
}

RouteValidation.propTypes = {
  paramKey: PropTypes.string,
  queryKey: PropTypes.string,
  schema: PropTypes.object.isRequired,
  redirectTo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.node,
}
